/* Aereo: comportamiento del carrito lateral (snippets/aereo-cart.liquid). Usa el carrito del theme (assets/cart.js)
   para cambiar cantidades, agregar y refrescar; aquí solo se conecta la interfaz nueva. Sin dependencias. */
(function () {
  if (window.aereoCartReady) return;
  window.aereoCartReady = true;

  var handle = function (text) {
    return String(text).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  };

  // Círculos de color con la configuración de swatches del theme (igual que las tarjetas de colección)
  function paintSwatches(scope) {
    var swatches = (window.theme && theme.swatches) || {};
    scope.querySelectorAll('[data-aereo-ckit-color]').forEach(function (el) {
      if (el.dataset.painted) return;
      var key = handle(el.dataset.aereoCkitColor);
      var value = swatches[key];
      if (value && CSS.supports('color', value)) el.style.backgroundColor = value;
      else if (value) el.style.backgroundImage = 'url(' + value + ')';
      else if (CSS.supports('color', key)) el.style.backgroundColor = key;
      el.dataset.painted = 'true';
    });
  }

  // Al refrescar, el theme trae el HTML nuevo; se cambian solo los bloques data-aereo-region para no perder
  // la nota que se está escribiendo ni el botón de pagar (el theme guarda referencias a ambos).
  customElements.whenDefined('cart-root').then(function () {
    var Cart = customElements.get('cart-root');
    var original = Cart.prototype.swapInNewContent;
    Cart.prototype.swapInNewContent = function (fresh) {
      if (!this.hasAttribute('data-aereo-cart')) return original.call(this, fresh);
      var root = this;
      var kitList = root.querySelector('[data-aereo-ckit-list]');
      var kitScroll = kitList ? kitList.scrollLeft : 0;
      var oldItems = {};
      root.querySelectorAll('.aereo-cart__item').forEach(function (item) { oldItems[item.dataset.variantId] = item; });

      fresh.querySelectorAll('[data-aereo-region]').forEach(function (region) {
        var current = root.querySelector('[data-aereo-region="' + region.dataset.aereoRegion + '"]');
        if (!current) return;
        // Reusa las fotos que ya estaban cargadas para que no parpadeen
        region.querySelectorAll('.aereo-cart__item').forEach(function (item) {
          var old = oldItems[item.dataset.variantId];
          var oldImg = old && old.querySelector('.aereo-cart__img');
          var newImg = item.querySelector('.aereo-cart__img');
          if (oldImg && newImg) newImg.replaceWith(oldImg);
        });
        current.replaceWith(region);
      });

      var head = root.querySelector('[data-aereo-region="head"]');
      if (head) root.setAttribute('data-has-items', String(parseInt(head.dataset.count, 10) > 0));
      var newKit = root.querySelector('[data-aereo-ckit-list]');
      if (newKit) newKit.scrollLeft = kitScroll;
      paintSwatches(root);
    };
  });

  function cartRoot(el) { return el.closest('[data-aereo-cart]'); }

  function updateLine(item, quantity) {
    var root = cartRoot(item);
    if (!root || typeof root.tryToUpdateQuantity !== 'function') return;
    item.classList.add('is-loading');
    root.tryToUpdateQuantity(item.dataset.lineNum, quantity).finally(function () {
      item.classList.remove('is-loading');
    });
  }

  // Tallas del color elegido en una tarjeta de "Completa tu kit"
  function selectColor(card, swatch) {
    card.querySelectorAll('[data-aereo-ckit-color]').forEach(function (s) { s.setAttribute('aria-pressed', String(s === swatch)); });
    var img = card.querySelector('.aereo-cart__kit-img img');
    if (img && swatch.dataset.image) { img.removeAttribute('srcset'); img.src = swatch.dataset.image; }
    var data = card.querySelector('[data-aereo-ckit-variants]');
    var sizes = card.querySelector('[data-aereo-ckit-sizes]');
    if (!data || !sizes) return;
    var color = swatch.dataset.aereoCkitColor;
    var variants = JSON.parse(data.textContent).filter(function (v) { return v.c === color; });
    sizes.innerHTML = '';
    variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'aereo-cart__kit-size';
      b.dataset.aereoCkitAdd = v.id;
      b.disabled = !v.a;
      b.setAttribute('aria-label', 'Agregar talla ' + v.s);
      b.innerHTML = '<span></span><span class="aereo-spinner" aria-hidden="true"></span>';
      b.firstChild.textContent = v.s;
      sizes.appendChild(b);
    });
  }

  function addFromKit(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ id: btn.dataset.aereoCkitAdd, quantity: 1 }).toString()
    };
    var done = function () { btn.setAttribute('aria-busy', 'false'); };
    if (window.theme && theme.cart && theme.cart.addItem) {
      theme.cart.addItem(opts, btn).then(done, done);
    } else {
      fetch('/cart/add.js', opts).then(function () { window.location.reload(); });
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('[data-aereo-cart]')) return;

    if (t.closest('[data-aereo-cart-close]')) {
      e.preventDefault();
      if (window.theme && theme.drawer) theme.drawer.close();
      return;
    }

    var qty = t.closest('[data-aereo-qty]');
    if (qty && !qty.disabled) {
      var item = qty.closest('.aereo-cart__item');
      var value = item.querySelector('[data-aereo-qty-value]');
      var next = Math.max(1, parseInt(value.textContent, 10) + parseInt(qty.dataset.aereoQty, 10));
      value.textContent = next;
      updateLine(item, next);
      return;
    }

    var remove = t.closest('[data-aereo-remove]');
    if (remove) { updateLine(remove.closest('.aereo-cart__item'), 0); return; }

    var swatch = t.closest('[data-aereo-ckit-color]');
    if (swatch) { selectColor(swatch.closest('[data-aereo-ckit-card]'), swatch); return; }

    var add = t.closest('[data-aereo-ckit-add]');
    if (add && !add.disabled) addFromKit(add);
  });

  // Nota del pedido: la casilla abre el campo; al desmarcarla se borra la nota (el theme la guarda al escribir)
  document.addEventListener('change', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-aereo-note-toggle]');
    if (!toggle) return;
    var field = cartRoot(toggle).querySelector('.aereo-cart__note-field');
    field.hidden = !toggle.checked;
    if (toggle.checked) { field.focus(); return; }
    if (field.value !== '') {
      field.value = '';
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });

  // Al vaciarse el carrito, el theme borra la nota: la casilla se desmarca también
  window.addEventListener('theme:cart:updated', function () {
    document.querySelectorAll('[data-aereo-cart]').forEach(function (root) {
      var field = root.querySelector('.aereo-cart__note-field');
      var toggle = root.querySelector('[data-aereo-note-toggle]');
      if (field && toggle && root.getAttribute('data-has-items') === 'false') { toggle.checked = false; field.hidden = true; }
    });
  });

  // Seguro contra el carrito trabado: el theme espera el fin de la animación (transitionend) para pasar a
  // "opened" o "closed". Si algo la corta (ej. el popup de Klaviyo), esa señal no llega y el carrito queda a
  // medias. Si sigue igual a los 800 ms, se manda la señal para que el theme termine solo.
  ['opening', 'closing'].forEach(function (step) {
    window.addEventListener('theme:drawer:right:' + step, function () {
      var drawer = window.theme && theme.drawer;
      if (!drawer || !drawer.state || drawer.state.view !== 'cart-drawer') return;
      var instance = drawer.state.instance;
      setTimeout(function () {
        if (drawer.status === step && instance) instance.dispatchEvent(new Event('transitionend'));
      }, 800);
    });
  });

  document.querySelectorAll('[data-aereo-cart]').forEach(paintSwatches);
})();
